import { z } from "zod"

const gaugeBribesItem = z.object({
  address: z.string(),
  apr: z.string(),
  aprLastEpoch: z.string(),
  bribeAddress: z.string(),
  incentives: z.record(
    z.string(),
    z.object({
      priceUsd: z.number(),
      rewardAmount: z.number(),
      rewardAmountUsd: z.number(),
      symbol: z.string(),
    }),
  ),
  pair: z.object({
    address: z.string(),
    displayName: z.string().nullable(),
    displayType: z.string().nullable(),
    extendedType: z.string().nullable(),
    tags: z.array(z.string()),
    tvlUsd: z.number(),
  }),
  rewardRate: z.string(),
  token0: z.object({
    address: z.string(),
    symbol: z.string(),
    tags: z.array(z.string()),
  }),
  token1: z.object({
    address: z.string(),
    symbol: z.string(),
    tags: z.array(z.string()),
  }),
  totalBribeValueUsd: z.string(),
  totalSupply: z.string(),
  votes: z.string(),
  votesPercent: z.string(),
})

export const gaugeBribesResponseSchema = z.record(z.string(), gaugeBribesItem)

export type GaugeBribesResponse = z.infer<typeof gaugeBribesResponseSchema>
export type GaugeBribesResponseItem = GaugeBribesResponse[number]
